import { z } from 'zod';
import { ErrorResponseSchema } from '@/schemas/common/base';

/**
 * Notification types enum
 */
export const NotificationTypeSchema = z.enum(['chat', 'sale', 'purchase', 'transaction', 'system']);
export type NotificationType = z.infer<typeof NotificationTypeSchema>;

/**
 * PUT /api/notifications/read-all query parameters schema
 * Optional type filter to mark only notifications of a specific type as read
 */
export const ReadAllQuerySchema = z.object({
  type: NotificationTypeSchema.optional(),
});

export type ReadAllQuery = z.infer<typeof ReadAllQuerySchema>;

/**
 * PUT /api/notifications/read-all success response schema
 */
export const ReadAllSuccessResponseSchema = z.object({
  success: z.literal(true),
  count: z.number(),
});

export type ReadAllSuccessResponse = z.infer<typeof ReadAllSuccessResponseSchema>;

/**
 * PUT /api/notifications/read-all response schema
 * Uses discriminated union on 'success' field for type-safe error handling
 */
export const ReadAllResponseSchema = z.discriminatedUnion('success', [
  ReadAllSuccessResponseSchema,
  ErrorResponseSchema,
]);

export type ReadAllResponse = z.infer<typeof ReadAllResponseSchema>;
